/*
 * Copyright (c) 2026, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import * as v from "valibot"

import { nonBlankString } from "../../utils/non-blank-string"

// Keep each rule separate so validation reports every requirement the password
// still fails instead of stopping at the first failure.
const newPassword = v.pipe(
    v.string(),
    v.minLength(8, "Password must be 8 or more characters in length."),
    v.regex(/[A-Z]/, "Password must contain 1 or more uppercase characters."),
    v.regex(/[0-9]/, "Password must contain 1 or more digit characters."),
    v.regex(/[!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/, "Password must contain 1 or more special characters.")
)

const passwordsMatch = (input: { newPassword: string; confirmPassword: string }) =>
    input.newPassword === input.confirmPassword

const mismatchMessage = "Passwords do not match."

// Attach the mismatch to the confirmation field so the error appears next to
// the value that needs correcting. This is repeated in each schema because
// extracting it into a generic helper prevents Valibot from type-checking the paths.
export const ResetPasswordSchema = v.pipe(
    v.object({ newPassword, confirmPassword: v.string() }),
    v.forward(v.partialCheck([["newPassword"], ["confirmPassword"]], passwordsMatch, mismatchMessage), [
        "confirmPassword"
    ])
)

export const ChangePasswordSchema = v.pipe(
    v.object({ oldPassword: nonBlankString("Enter your old password."), newPassword, confirmPassword: v.string() }),
    v.forward(v.partialCheck([["newPassword"], ["confirmPassword"]], passwordsMatch, mismatchMessage), [
        "confirmPassword"
    ])
)
